/**
 * Accordion: toggle accordion panels
 */
(function($) {
  "use strict";

  $(window).ready(init);

  // Constants
  var CONTAINER_SEL = ".field--name-field-accordion-item"; /*accordeon block parent*/
  var CONTROL_SEL = ".field--name-field-titre-accordion-item"; /*accordeon item title*/
  var PANEL_SEL = ".field--name-field-contenu-accordion-item"; /*accordeon item content*/


  /**
   * Init
   */
  function init() {
      var lightaccordion = $(".paragraph--type--lightaccordion .field--name-field-titre-accordion-item")
      if(lightaccordion.length > 0){
          lightaccordion.append("<button class=\"LightAccordion-toggle\">Voir</button>");
      }

      var lightaccordionhome = $(".paragraph--type--accordion .field--name-field-titre-accordion-item")
      if(lightaccordionhome.length > 0){
          lightaccordionhome.append("<button class=\"Accordion-toggle\">Voir</button>");
      }


    var container = $(CONTAINER_SEL);
    if (container.length === 0) {
      return;
    }

    container.find(CONTROL_SEL).attr('aria-expanded', 'false');
    container.find(PANEL_SEL).hide();
    var window_size = $(window).height();
    var spaced = window_size / 3;

    container.on("click", CONTROL_SEL + "[aria-expanded=false]", function() {
      var header = $(this);
      var panel = header.next();
      container.find(CONTROL_SEL).attr('aria-expanded', 'false');
      container.find(PANEL_SEL).attr('aria-hidden', 'true').slideUp();
      header.attr("aria-expanded", "true");
      panel
        .attr("aria-hidden", "false")
        .slideDown(function () {
          $('html,body').animate({scrollTop: $(CONTROL_SEL + '[aria-expanded=true]').offset().top - spaced}, 'slow');
        });

    });

    container.on("click", CONTROL_SEL + "[aria-expanded=true]", function() {
      var header = $(this);
      var panel = header.next();
      container.find(CONTROL_SEL).attr('aria-expanded', 'false');
      container.find(PANEL_SEL).attr('aria-hidden', 'true').slideUp();
    });
  }


})(jQuery);
